import { render, staticRenderFns } from "./TableFrame.vue?vue&type=template&id=607b82b2&"
import script from "./TableFrame.vue?vue&type=script&lang=js&"
export * from "./TableFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('607b82b2', component.options)
    } else {
      api.reload('607b82b2', component.options)
    }
    module.hot.accept("./TableFrame.vue?vue&type=template&id=607b82b2&", function () {
      api.rerender('607b82b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/utils/datatable/Table/TableFrame.vue"
export default component.exports